"use strict";

exports.__esModule = true;
exports.default = void 0;
var _locale = require("date-fns/locale");
var _i18n = require("@ellucian/react-design-system/core/i18n");
var supportedLocales = {
  'en-US': _locale.enUS,
  en_US: _locale.enUS,
  'en-GB': _locale.enGB,
  en_GB: _locale.enGB,
  'en-AU': _locale.enAU,
  en_AU: _locale.enAU,
  es: _i18n.dateFormats.es,
  'es-CL': _i18n.dateFormats.esCL,
  es_CL: _i18n.dateFormats.esCL,
  'es-MX': _i18n.dateFormats.esMX,
  es_MX: _i18n.dateFormats.esMX,
  'es-CO': _i18n.dateFormats.esCO,
  es_CO: _i18n.dateFormats.esCO,
  'es-EC': _i18n.dateFormats.esEC,
  es_EC: _i18n.dateFormats.esEC,
  'es-PE': _i18n.dateFormats.esPE,
  es_PE: _i18n.dateFormats.esPE,
  'es-DO': _i18n.dateFormats.esDO,
  es_DO: _i18n.dateFormats.esDO,
  'es-PR': _i18n.dateFormats.esPR,
  es_PR: _i18n.dateFormats.esPR,
  fr: _locale.fr,
  'fr-CA': _locale.frCA,
  fr_CA: _locale.frCA,
  ar: _locale.ar
};
var _default = exports.default = supportedLocales;